import type { ThemePayload } from "../../schemas/Theme";

export function isGradientTheme(theme: ThemePayload): boolean {
  return theme.type === "Gradient";
}
